import { ReactElement, useLayoutEffect } from 'react';
import { GridRenderCellParams, useGridApiContext, useGridRootProps } from '@mui/x-data-grid-premium';
import { SpotRadio } from '@enterprise/spot';
import styles from './radioSelectorCell.module.scss';
import classNames from 'classnames';

export const RadioSelectorCell = (props: GridRenderCellParams): ReactElement => {
    const { field, id, value, tabIndex } = props;
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const element = apiRef.current.getCellElement(id, field);
    const row = apiRef.current.getRow(id);
    const isSelectable = row != null && (!rootProps?.isRowSelectable || rootProps?.isRowSelectable({ id, row, columns: rootProps.columns as any[] }));
    const handleChange = () => {
        apiRef.current.setRowSelectionModel([id]);
    };

    useLayoutEffect(() => {
        if (tabIndex === 0 && element) {
            element.tabIndex = -1;
        }
    }, [element, tabIndex]);

    return (
        <div className={classNames({ [styles.hidden]: !isSelectable })}>
            <SpotRadio
                id={`data-grid-radiobox-selector-${id}`}
                className={styles.radio}
                name={'data-grid-radiobox-selector'}
                value={id}
                checked={Boolean(value)}
                onChange={() => handleChange()}
                ata-automation-id="data-grid-selector-cell"
            />
        </div>
    );
};
